import React from "react";
import styled from "styled-components";

const TAB_HOVER_COLOR = "#F7941D";

const TabsContainer = styled.ul`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  list-style-type: none;
  border-bottom: 2px solid #ccc;
  padding: 0;
  margin: 0 0 1rem 0;

  li {
    margin: 0 15px 10px 0;
  }

  a {
    display: inline-block;
    text-decoration: none;
    padding: 10px 15px;
    border: 1px solid transparent;
    border-radius: 5px;
    background-color: ${({ colors }) => colors.cardBackground};
    color: ${({ colors }) => colors.buttonBackground};
    transition: all 0.3s;
    font-weight: 600;

    &.selected {
      background-color: ${({ colors }) => colors.buttonBackground};
      color: white;
      border-color: ${({ colors }) => colors.buttonBackground};
    }

    &:not(.selected) {
      background-color: ${({ colors }) => colors.titleText};
      color: ${({ colors }) => colors.buttonBackground};
    }

    &:hover {
      background-color: ${TAB_HOVER_COLOR};
      border-color: ${TAB_HOVER_COLOR};
      color: white;
    }
  }
`;

const OtherTabs = ({ colors, selectedTab, handleTabClick }) => {
  const tabs = [
    "Announcements",
    "Resources",
    "Salespersons",
    "Sales Regions",
    "Product Codes",
    "Organization Types",
    "Merge Accounts",
    "Renewals",
    "Email Log",
    "Quotes",
    "Webinar"
  ];

  return (
    <TabsContainer colors={colors}>
      {tabs.map((tab) => (
        <li key={tab}>
          <a
            href="#"
            className={selectedTab === tab ? "selected" : ""}
            onClick={() => handleTabClick(tab)}
          >
            {tab}
          </a>
        </li>
      ))}
    </TabsContainer>
  );
};

export default OtherTabs;
